import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Page } from '../../../models/page-wrapper.model';
import { Location } from './locations.model';

/**
 * Service for interacting with the Location API endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private apiUrl = `${environment.restApiUrl}masterdata/locations`;

  constructor(private http: HttpClient) {}

  /**
   * Retrieves a paginated list of locations, with optional filtering.
   * @param params - HTTP parameters for filtering, sorting, and pagination.
   * @returns An Observable of a Page of Locations.
   */
  getLocations(params: HttpParams): Observable<Page<Location>> {
    return this.http.get<Page<Location>>(this.apiUrl+'/search', { params });
  }

  /**
   * Retrieves a single location by its ID.
   * @param id - The ID of the location.
   * @returns An Observable of the Location.
   */
  getLocationById(id: number): Observable<Location> {
    return this.http.get<Location>(`${this.apiUrl}/${id}`);
  }

  /**
   * Deletes a location by its ID.
   * @param id - The ID of the location to delete.
   * @returns An Observable of void.
   */
  deleteLocation(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
